/** Per diem / day rates — all delivery staff are hourly. */
export const PER_DIEM_SUPERVISOR_RATE = 200;
export const PER_DIEM_TEAM_MEMBER_RATE = 175;

export function calculatePerDiemTotal(supervisors, teamMembers, days) {
  const s = parseInt(supervisors, 10) || 0;
  const t = parseInt(teamMembers, 10) || 0;
  const d = Math.max(1, parseInt(days, 10) || 1);
  return s * PER_DIEM_SUPERVISOR_RATE * d + t * PER_DIEM_TEAM_MEMBER_RATE * d;
}

export function formatPerDiemExplanation(supervisors, teamMembers, days) {
  const s = parseInt(supervisors, 10) || 0;
  const t = parseInt(teamMembers, 10) || 0;
  const d = Math.max(1, parseInt(days, 10) || 1);
  if (s <= 0 && t <= 0) return null;

  const parts = [];
  if (s > 0) {
    parts.push(
      `${s} supervisor${s !== 1 ? 's' : ''} × $${PER_DIEM_SUPERVISOR_RATE} × ${d} day${d !== 1 ? 's' : ''}`
    );
  }
  if (t > 0) {
    parts.push(
      `${t} team member${t !== 1 ? 's' : ''} × $${PER_DIEM_TEAM_MEMBER_RATE} × ${d} day${d !== 1 ? 's' : ''}`
    );
  }
  const total = calculatePerDiemTotal(s, t, d);
  return `${parts.join(' + ')} = $${total.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
